<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
    <el-dialog
      :visible.sync="showDialog"    
      width="520px" 
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title="rs.update_available"
      class="refresh-dialog"
    > 
      <p>{{ rs.err_msg_session_expired }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button class="small primary" @click="handleDoLogin">
          <svg-icon name="refresh" /><span>{{ rs.refresh_now }}</span>
        </el-button>
      </span>
    </el-dialog>    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userLogin } from '@/api/userApi.js'
import { getTs, getTimeZone } from "@/assets/js/time.js";
import tldjs from 'tldjs';
import socketMixin from '@/mixins/socketMixin';

export default {
  name: "App",
  mixins: [socketMixin],
  provide(){
    return{
      reload:this.reload,
    }
  },
  data() {
    return {
      userId: 1,
      name: "Unknown User",
      email: "",
      isRouterAlive: true,
      showDialog: false,
      formData:{
        email:'',
        password:'',
        usertype:"01"
      },
    };
  },
  created() {
    this.userId = "agency" + getTs();

    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    } 

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })

    if (this.sessionExpired) {
      this.showDialog = true;
    } else {
      this.showDialog = false;
      setTimeout(() => {
        this.initSocket();
      }, 3000);
    }
  },
  methods:{
    toStartIntercom() {
      if (this.$router.history.current.fullPath == '/lead_qr_form') {
        this.$intercom.shutdown()
        return
      } else {
        this.$intercom.boot({
          user_id: this.userId,
          name: this.name,
          email: this.email,
        })
      }
    },
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    handleDoLogin(){
      if(localStorage.getItem('LocalUser')){
        this.formData = JSON.parse(localStorage.getItem('LocalUser'))
      }
      if (this.formData.password) {
        var host = tldjs.getDomain(location.host);
        userLogin({...this.formData, timezone: getTimeZone(), domain: host}).then(res=>{
          if (res.data.success) {
            this.showDialog = false;
            this.$store.commit("SESSION_EXPIRED", false);
            this.$store.commit("TOKEN", res.data.token);
            sessionStorage.setItem("token", res.data.token);//token存本地
          // Socket链接
          this.initSocket();

        } else {
            this.$message.error({message:res.data.errorMsg});          
          }
        });
      } else {
        this.showDialog = false;
        this.$store.commit("SESSION_EXPIRED", false);

        var agencyData = localStorage.getItem('agencyData');
        if (agencyData) {
          agencyData = JSON.parse(agencyData);
          this.$router.push({ path: '/', query:{
            agencyid: agencyData.agencyid,
            languagetype: agencyData.languagetype
          } })
          localStorage.removeItem('agencyData');
        } else {
          this.$router.push({ path: '/'})
        }
      }
    },
  },
  mounted() {
    this.toStartIntercom();
    // this.$intercom.show();
    if (localStorage.getItem("userInfo")) {
        this.userId = "agency" + getTs();
      this.name =
        JSON.parse(localStorage.getItem("userInfo")).firstname +
        " " +
        JSON.parse(localStorage.getItem("userInfo")).lastname;
      this.email = JSON.parse(localStorage.getItem("userInfo")).email;
    }
  },
  watch: {
    // email(email) {
    //   this.$intercom.update({ email });
    // },
    // name(name) {
    //   this.$intercom.update({ name });
    // },
    // userId(user_id) {
    //   this.$intercom.update({ user_id });
    // },
    // logintype(val) {
    //   if (val == "0") {
    //     this.userId = "agency" + getTs();
    //     this.name = "Unknown User";
    //     this.email = "";
    //   } else {
    //     this.userId = "agency" + getTs();
    //     this.name =
    //       JSON.parse(localStorage.getItem("userInfo")).firstname +
    //       " " +
    //       JSON.parse(localStorage.getItem("userInfo")).lastname;
    //     this.email = JSON.parse(localStorage.getItem("userInfo")).email;
        
    //   }
    // }
    email(email) {
      if (this.$router.history.current.fullPath != '/lead_qr_form') {
        this.$intercom.update({ email })
      }
    },
    name(name) {
      if (this.$router.history.current.fullPath != '/lead_qr_form') {
        this.$intercom.update({ name })
      }
    },
    userId(user_id) {
      if (this.$router.history.current.fullPath != '/lead_qr_form') {
        this.$intercom.update({ user_id })
      }
    },
    logintype(val) {
      if (val == "0") {
        this.userId = "agency" + getTs();
        this.name = "Unknown User";
        this.email = "";
        this.toStartIntercom();
      } else {
        this.userId = "agency" + getTs();
        this.name =
          JSON.parse(localStorage.getItem("userInfo")).firstname +
          " " +
          JSON.parse(localStorage.getItem("userInfo")).lastname;
        this.email = JSON.parse(localStorage.getItem("userInfo")).email;
        this.toStartIntercom();
      }
    },
    sessionExpired(val) {
      if (val) {
        this.showDialog = true;
      } else {
        this.showDialog = false;
      }
    }
  },
  computed: {
    ...mapGetters(["rs", "logintype", "sessionExpired"])
  }
};
</script>

<style lang="scss">
.refresh-dialog {
  .el-dialog__title {
    padding-left: 20px;
  }
  .el-dialog__body {
    >p {
      line-height: 30px;
    }
  }
  .dialog-footer {
    padding-top: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue